import { NgClass } from '@angular/common';
import { Component, forwardRef, inject } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TrailerFuelLevelMerge } from 'shared/enums';
import { EnumHelper } from 'shared/helpers';

@Component({
  selector: 'app-fuel-level',
  templateUrl: './fuel-level.component.html',
  styles: ``,
  imports: [MatSliderModule, NgClass, TranslateModule, ReactiveFormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FuelLevelComponent),
      multi: true,
    },
  ],
})
export class FuelLevelComponent implements ControlValueAccessor {
  public isDisabled = false;

  public readonly fuelValues: string[] = EnumHelper.toValueArray(TrailerFuelLevelMerge);
  private _valueNumber = 4;

  public get valueNumber(): number {
    return this._valueNumber;
  }

  public set valueNumber(value: number) {
    this._valueNumber = value;
    this.onChange(this.fuelValues[value]);
  }

  private translateSvc = inject(TranslateService);

  public formatSliderLabel = (value: number): string => {
    return this.translateSvc.instant(`yardControl.lists.fuelLevel.${this.fuelValues[value]}`);
  };

  // ControlValueAccessor stuff
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public onChange = (value: string | null): void => {
    //placeholder implementation
  };
  public onTouched = (): void => {
    //placeholder implementation
  };

  public writeValue(value: string | null): void {
    if (value === null) {
      this._valueNumber = 4;
    } else {
      this.valueNumber = this.fuelValues.indexOf(value);
    }
  }

  public registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => string): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
